import { kea } from 'kea'
import PropTypes from 'prop-types'

import profilePhotoLogic from '~/scenes/layout/logic'

import controller from './controller.rb'

export default kea({
  initScene: {
    scene: 'courseShow',

    transform: payload => ({
      helmet: payload.helmet,
      course: payload.course,
      timezone: payload.timezone,
      user: payload.user,
      video: payload.video,
      facebookApp: payload.facebookApp
    })
  },

  path: () => ['scenes', 'courseShow', 'index'],

  dimensions: {
    windowWidth: [typeof window !== 'undefined' && window.innerWidth, window => window.innerWidth]
  },

  connect: {
    props: [profilePhotoLogic, ['avatar']]
  },

  actions: () => ({
    translate: locale => ({ locale }),
    translateCourse: locale => ({ locale }),
    gotTranslation: course => ({ course }),
    translateProfile: locale => ({ locale }),
    translateReview: (reviewId, locale) => ({ reviewId, locale }),
    loadMore: true,
    gotMoreReviews: ({ reviews }) => ({ reviews }),
    gotReviewTranslation: review => ({ review }),
    setHoverLocation: location => ({ location }),
    updateCourseAvailability: availability => ({ availability }),
    updateAvailabilityTimezone: timezone => ({ timezone }),
    enableSharing: true,
    disableSharing: true,
    openModal: true
  }),

  reducers: ({ actions }) => ({
    helmet: [{}, PropTypes.object, {}],
    isOpenModal: [
      false,
      PropTypes.bool,
      {
        [actions.openModal]: (state, _) => !state
      }
    ],
    isShareVisible: [
      false,
      PropTypes.bool,
      {
        [actions.enableSharing]: () => true,
        [actions.disableSharing]: () => false
      }
    ],

    course: [
      null,
      PropTypes.object,
      {
        [actions.gotMoreReviews]: (state, { reviews }) => {
          return {
            ...state,
            reviews: {
              ...state.reviews,
              reviews: [...state.reviews.reviews, ...reviews]
            }
          }
        },
        [actions.gotTranslation]: (state, { course }) => {
          const { reviews } = state
          return { ...course, reviews }
        },
        [actions.updateCourseAvailability]: (state, { availability }) => {
          return { ...state, availability }
        },
        [actions.gotReviewTranslation]: (state, { review }) => {
          const updatedReviews = state.reviews.reviews.map(stateReview =>
            stateReview.id === review.id ? review : stateReview
          )
          const reviews = { ...state.reviews, reviews: updatedReviews }

          return { ...state, reviews }
        }
      }
    ],
    timezone: [
      '',
      PropTypes.string,
      {
        [actions.updateAvailabilityTimezone]: (_, { timezone }) => timezone
      }
    ],
    user: [null, PropTypes.object, {}],

    translating: [
      false,
      PropTypes.bool,
      {
        [actions.translate]: () => true,
        [actions.translateCourse]: () => true,
        [actions.translateProfile]: () => true,
        [actions.translateReview]: () => true,
        [actions.gotTranslation]: () => false,
        [actions.gotReviewTranslation]: () => false
      }
    ],

    hoverLocation: [
      0,
      PropTypes.number,
      {
        [actions.setHoverLocation]: (_, { location }) => location
      }
    ],
    isLoading: [
      false,
      PropTypes.bool,
      {
        [actions.loadMore]: () => true,
        [actions.gotMoreReviews]: () => false
      }
    ],
    video: [null, {}],
    facebookApp: ['', PropTypes.string, {}]
  }),

  selectors: ({ selectors }) => ({
    isMobile: [() => [selectors.windowWidth], windowWidth => windowWidth < 632],
    userData: [
      () => [selectors.user, selectors.avatar],
      (user, avatar) => {
        return avatar ? { ...user, avatarUrl: avatar } : user
      },
      PropTypes.object
    ]
  }),

  listeners: ({ actions, values }) => ({
    [actions.loadMore]: async function () {
      const { gotMoreReviews } = actions
      const { id } = values.user
      const response = await controller.loadReviews({ id })
      gotMoreReviews(response)
    }
  })
})
